// Mock data for the website

export const testimonials = [
  {
    id: 1,
    name: "Michael Rodriguez",
    company: "TechStart Solutions",
    text: "Outstanding service! They handled our trademark registration efficiently and kept us informed throughout the entire process. Highly professional team.",
    rating: 5
  },
  {
    id: 2,
    name: "Sarah Chen",
    company: "Bloom Beauty Co.",
    text: "Trademark Inspire made the complex trademark process simple and straightforward. Their expertise saved us time and money. Couldn't be happier with the results!",
    rating: 5
  },
  {
    id: 3,
    name: "James Patterson",
    company: "Patterson Consulting",
    text: "Professional, responsive, and knowledgeable. They guided us through every step of our trademark application. The platinum package was worth every penny.",
    rating: 5
  },
  {
    id: 4,
    name: "Emily Thompson",
    company: "Creative Minds Agency",
    text: "Excellent customer service and expertise. They helped us protect our brand identity quickly and effectively. I recommend them to all my business colleagues.",
    rating: 5
  },
  {
    id: 5,
    name: "David Martinez",
    company: "Martinez Innovations",
    text: "From start to finish, the experience was seamless. Their comprehensive search report gave us confidence that our trademark would be approved.",
    rating: 5
  },
  {
    id: 6,
    name: "Lisa Anderson",
    company: "Anderson & Associates",
    text: "The team at Trademark Inspire is incredibly knowledgeable and professional. They made trademark registration stress-free and delivered exactly what they promised.",
    rating: 5
  }
];

export const processSteps = [
  {
    id: 1,
    step: "Step 1",
    title: "Submit & Search",
    description: "Fill out our simple form with your trademark details. We conduct a comprehensive search of existing trademarks to ensure your mark is unique and has the best chance of approval."
  },
  {
    id: 2,
    step: "Step 2",
    title: "File & Process",
    description: "Our experts prepare and file your trademark application with the USPTO. We monitor your application status and handle any office actions promptly throughout the entire process."
  },
  {
    id: 3,
    step: "Step 3",
    title: "Secure & Protect",
    description: "Once approved, your trademark is registered and fully protected. We provide ongoing monitoring services to safeguard your brand from potential infringement."
  }
];

export const benefits = [
  {
    id: 1,
    title: "Expert Guidance",
    description: "Our team of experienced trademark attorneys ensures your application is filed correctly the first time."
  },
  {
    id: 2,
    title: "Comprehensive Protection",
    description: "We provide end-to-end trademark services from search to registration and ongoing monitoring."
  },
  {
    id: 3,
    title: "Fast Turnaround",
    description: "Quick processing times with dedicated case managers ensuring your application moves forward efficiently."
  },
  {
    id: 4,
    title: "Affordable Pricing",
    description: "Transparent pricing with packages to fit every budget. No hidden fees or surprise charges."
  },
  {
    id: 5,
    title: "High Success Rate",
    description: "Our thorough search and preparation process results in one of the highest approval rates in the industry."
  },
  {
    id: 6,
    title: "Ongoing Support",
    description: "Continue support even after registration with monitoring services and legal assistance when needed."
  }
];

export const pricingPlans = [
  {
    id: 1,
    name: "Essentials",
    price: "$45",
    subtitle: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Basic Search",
      "State E-Filing",
      "Trademark Secured"
    ],
    note: "Govt. filing fee not included",
    recommended: false
  },
  {
    id: 2,
    name: "Enhanced",
    price: "$149",
    subtitle: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter"
    ],
    note: "Govt. filing fee not included",
    recommended: false
  },
  {
    id: 3,
    name: "Deluxe",
    price: "$299",
    subtitle: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager"
    ],
    note: "Govt. filing fee not included",
    recommended: true
  },
  {
    id: 4,
    name: "Platinum",
    price: "$349",
    subtitle: "+ Federal Filing Fee",
    features: [
      "Case Review",
      "Case Filing",
      "Direct Hit Search",
      "Trademark Alert",
      "Trademark Secured",
      "High Satisfaction Rate",
      "Refusal Risk Meter",
      "Trademark Monitoring",
      "Complete Documentation",
      "Digital File",
      "Dedicated Case Manager",
      "High Approval Rate",
      "Comprehensive Search Report",
      "High Priority Service",
      "Cease & Desist Letter"
    ],
    note: "Govt. filing fee not included",
    recommended: false
  }
];

export const services = [
  {
    category: "Trademark Services",
    items: [
      { name: "Register Your Trademark", path: "/services/register-trademark" },
      { name: "Clearance Search Services", path: "/services/clearance-search" },
      { name: "Trademark Ownership Transfers", path: "/services/ownership-transfers" },
      { name: "Submission of Statements of Use", path: "/services/statements-of-use" },
      { name: "Support and Response for Trademark Office Actions", path: "/services/office-actions" },
      { name: "Active Monitoring for Trademark infringement", path: "/services/monitoring" },
      { name: "File TTAB Petition", path: "/services/ttab-petition" }
    ]
  },
  {
    category: "Company Formation Services",
    items: [
      { name: "Limited Liability Company", path: "/services/llc" },
      { name: "C Corporation", path: "/services/c-corporation" },
      { name: "S Corporation", path: "/services/s-corporation" },
      { name: "Non-Profit", path: "/services/non-profit" }
    ]
  },
  {
    category: "Copyright Services",
    items: [
      { name: "Register Your Copyright", path: "/services/register-copyright" },
      { name: "Assistance for Your Copyright Enforcement", path: "/services/copyright-enforcement" },
      { name: "Copyright Transfers and Licensing Support", path: "/services/copyright-transfers" },
      { name: "Legal Representation for Your Copyright", path: "/services/copyright-representation" },
      { name: "Management of Your Copyright Portfolio", path: "/services/copyright-portfolio" },
      { name: "Compliance with DMCA Act", path: "/services/dmca-compliance" }
    ]
  },
  {
    category: "Patent Services",
    items: [
      { name: "Search for Existing Patent", path: "/services/patent-search" },
      { name: "Support and Response for Patent Office Actions", path: "/services/patent-office-actions" },
      { name: "Application Submission for Patent", path: "/services/patent-application" },
      { name: "Legal Representation for Patent Protection", path: "/services/patent-representation" }
    ]
  },
  {
    category: "Legal Services",
    items: [
      { name: "Business Immigration Law", path: "/services/immigration-law" },
      { name: "Due Diligence Process", path: "/services/due-diligence" },
      { name: "IT & Commercial Law", path: "/services/it-commercial-law" },
      { name: "Legal Services on Patnerships & LLPs", path: "/services/partnerships-llps" },
      { name: "Data Protection & Privacy Law", path: "/services/data-protection" }
    ]
  },
  {
    category: "Additional Corporate Services",
    items: [
      { name: "Amazon Brand Registry in the US", path: "/services/amazon-brand-registry" },
      { name: "Bookkeeping Service", path: "/services/bookkeeping" },
      { name: "Business Formation Services", path: "/services/business-formation" },
      { name: "Certificate of Good Standing", path: "/services/certificate-good-standing" },
      { name: "Company Dissolution", path: "/services/company-dissolution" },
      { name: "Company Name Change", path: "/services/company-name-change" },
      { name: "Company Renewal Services", path: "/services/company-renewal" },
      { name: "Issue Of Shares", path: "/services/issue-shares" },
      { name: "Nominee Director & Secretarial Services", path: "/services/nominee-director" },
      { name: "Tax Advisory & Filing", path: "/services/tax-advisory" },
      { name: "Transfer of Shares", path: "/services/transfer-shares" },
      { name: "CFO Services", path: "/services/cfo-services" }
    ]
  }
];

export const countryCodesList = [
  { code: "+1", country: "United States", id: "us" },
  { code: "+1", country: "Canada", id: "ca" },
  { code: "+44", country: "United Kingdom", id: "uk" },
  { code: "+61", country: "Australia", id: "au" },
  { code: "+91", country: "India", id: "in" },
  { code: "+86", country: "China", id: "cn" },
  { code: "+81", country: "Japan", id: "jp" },
  { code: "+49", country: "Germany", id: "de" },
  { code: "+33", country: "France", id: "fr" },
  { code: "+39", country: "Italy", id: "it" },
  { code: "+34", country: "Spain", id: "es" },
  { code: "+52", country: "Mexico", id: "mx" },
  { code: "+55", country: "Brazil", id: "br" },
  { code: "+27", country: "South Africa", id: "za" },
  { code: "+971", country: "United Arab Emirates", id: "ae" }
];
